import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SKIP_AUTH } from 'src/app/constants/ContextToken';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SysService {
  // local URL
  private readonly baseURL = environment.apiUrl;

  constructor(private http: HttpClient) { }

  // get user preference by userId and preferenceCode
  getUserPreference(userId: number, preferenceCode: string): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/user/preference/get-by-user?userId=${userId}&preferenceCode=${preferenceCode}`);
  }

  SaveUserPreference(item: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/user/preference/save`, item);
  }

  updateEmployeeUserStatus(controllerRoute: string, item: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/${controllerRoute}/update/employee-status`, item);
  }

  checkIfEmployeeUserIsAlreadyExists(controllerRoute: string, item: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/${controllerRoute}/check/user/is-exists`, item);
  }

  unlockUser(userId: number): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/User/update/isLockEnabled`, userId);
  }

  // add a new item
  submit(item: any, currentLang: string): Observable<any> {
    const headers = new HttpHeaders({
      'Accept-Language': currentLang
    });

    return this.http.post<any>(`${this.baseURL}/contact/us/submit`, item, {
      headers,
      context: new HttpContext().set(SKIP_AUTH, true)
    });
  }

  getContactDetailsByContactInfoId(controllerRoute: string, contactInfoId: number) {
    return this.http.get<any>(`${this.baseURL}/${controllerRoute}/get-contact-details-by-amenity-id?id=${contactInfoId}`);
  }

  deleteAccount(data: any) {
    return this.http.post(`${this.baseURL}/User/delete-account`, data);
  }

  getUsersByUserTypeId(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/User/get-by-user-type?userTypeId=${id}`);
  }

  getUserRolesByUserId(controllerRoute: string, userId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/${controllerRoute}/get-user-roles-by-user-id/${userId}`);
  }

  getUserDetailsById(controllerRoute: string, userId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/${controllerRoute}/details?userId=${userId}`);
  }

  getUsers(data: any): Observable<any> {
    return this.http.post(`${this.baseURL}/User/get-filtered-users`, data);
  }
  // ─── Currency ─────────────────────────────────────────────────
  getAllCurrencies(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/currency/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getCurrencyById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/currency/get-by-id?id=${id}`);
  }

  createCurrency(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/currency/create`, entity);
  }

  updateCurrency(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/currency/update`, entity);
  }

  // ─── Currency Rate ────────────────────────────────────────────
  getAllCurrencyRates(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/currency-rate/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getCurrencyRatesByCurrencyId(currencyId: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/currency-rate/get-by-currency-id?currencyId=${currencyId}`);
  }

  createCurrencyRate(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/currency-rate/create`, entity);
  }

  updateCurrencyRate(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/currency-rate/update`, entity);
  }

  // ─── DataSecuritySubject ──────────────────────────────────────
  getAllDataSecuritySubjects(status?: boolean | null): Observable<any> {
    let url = `${this.baseURL}/data-security-subject/get-all`;
    if (status !== null && status !== undefined) url += `?status=${status}`;
    return this.http.get<any>(url);
  }

  getDataSecuritySubjectById(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/data-security-subject/get-by-id?id=${id}`);
  }

  createDataSecuritySubject(entity: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/data-security-subject/create`, entity);
  }

  updateDataSecuritySubject(entity: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}/data-security-subject/update`, entity);
  }

  getConfigByKey(ConfigKey: string): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/Configuration/get-by-key?ConfigKey=${ConfigKey}`);
  }

  getCurrenctRateByCurrencyIdAndTransactionDate(currencyId: number, transactionDate: Date): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/currency-rate/get-by-currency-id-and-trans-date?currencyId=${currencyId}&transactionDate=${transactionDate}`);
  }

  getDataSecurityByRoleId(roleId: any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/data-security/get-by-role-id?roleId=${roleId}`)
  }

  getAllDataSecurityByRoleIds(roleIds: any[]): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/data-security/get-all-by-role-ids?roleIds=${roleIds.join(',')}`)
  }

  savedataSecurity(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/data-security/save`, data);
  }
  // ─── SideMenue ──────────────────────────────────────
  getSidemenueAuthority(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/side/menu/authority/get-with-authority`, data);
  }
  getSideMenu(payload: any): Observable<any> {
    return this.http.post(`${this.baseURL}/side/menu/details-with-pagination`, payload);
  }

  getAuthority(payload: any): Observable<any> {
    return this.http.post(`${this.baseURL}/Authority/get-details`, payload);
  }

  getUserRoleDelegationByDelegationId(delegationId: any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/user/role/delegation/get-delegation-details?delegationId=${delegationId}`)
  }

  impersonate(payload: any): Observable<any> {
    return this.http.post(`${this.baseURL}/login/impersonate`, payload);
  }

   getEmployeeUsers(): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/user/get-employee-users`)
  }

  cloneRole(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}/role/clone`, data)
  }
  
  getRoleDetailsFull(roleId: number, moduleIds: number[]): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/Role/get-role-details-full/${roleId}?moduleIds=${moduleIds.join(',')}`)
  }
}
